export default __webpack_public_path__ + "static/media/channel_hub_logo.d00d8384.png";